const getApiBase = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8000';
  }
  return '';
};

export const API_BASE = getApiBase();

export const IS_STAGING = process.env.REACT_APP_ENV === 'staging';
export const IS_PROD = process.env.REACT_APP_ENV === 'production';
export const ENV_BANNER_PX = 32;
export const STAGING_BANNER_PX = ENV_BANNER_PX;
export const LAYOUT_TOP_OFFSET = (IS_STAGING || IS_PROD) ? ENV_BANNER_PX : 0;
